import styled from "styled-components";

export const NotificationItemMetadata = styled.div`
    color: #888;
    font-size: 12px;
`;
